export const lightTheme = {
  body: '#f0f2f5',
  text: '#1c1e21',
  textSecondary: '#65676b',
  primary: '#1877f2',
  primaryHover: '#166fe5',
  secondary: '#42b72a',
  secondaryHover: '#36a420',
  background: '#ffffff',
  card: '#ffffff',
  divider: '#f0f2f5',
  border: '#dddfe2',
  messageHover: '#f7f8fa',
  inputBg: '#ffffff',
  shadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  overlay: 'rgba(255, 255, 255, 0.8)',
  success: '#4BB543',
  error: '#c00',
  hashtag: '#1877f2',
  buttonLight: '#f0f2f5',
  buttonText: '#65676b',
  buttonLightHover: '#e4e6eb'
};

export const darkTheme = {
  body: '#18191a',
  text: '#e4e6eb',
  textSecondary: '#b0b3b8',
  primary: '#2d88ff',
  primaryHover: '#1877f2',
  secondary: '#42b72a',
  secondaryHover: '#36a420',
  background: '#18191a',
  card: '#242526',
  divider: '#3a3b3c',
  border: '#3a3b3c',
  messageHover: '#2d2d2e',
  inputBg: '#3a3b3c',
  shadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
  overlay: 'rgba(0, 0, 0, 0.8)',
  success: '#4BB543',
  error: '#f44336',
  hashtag: '#2d88ff',
  buttonLight: '#3a3b3c',
  buttonText: '#b0b3b8',
  buttonLightHover: '#4a4b4c'
};
